import React, { Component } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import './CardList.scss';

export default class CardList extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.array.isRequired,
    liProps: PropTypes.object
  };

  render() {
    const { className, children, liProps } = this.props;
    const classComponent = classNames('card__list', className);

    return (
      <ul className={classComponent}>
        {children.map((card, index) => (
          <li {...liProps} key={index}>
            {card}
          </li>
        ))}
      </ul>
    );
  }
}
